import 'swiper/scss';
import * as carrouselStyles from '../../../styles/carrousels/carrousel.module.scss';
import PropTypes from 'prop-types';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import IconContainer from '../IconContainer';
import {useTranslation} from 'react-i18next';
import {arrayWithEnouthItemsCarrousel, toExternalUrl} from '../../../utils/utils';
import clsx from 'clsx';
import PolyLink from '../PolyLink';
import CustomBullets from './CustomBullets';

const FocusCarrousel = ({items}) => {
  const {t} = useTranslation();
  const filteredItems = arrayWithEnouthItemsCarrousel(items.filter((item) => (item?.media?.imageFile)), 8);
  const [swiper, setSwiper] = React.useState(null);
  const [display, setDisplay] = React.useState(false);
  const [slide, setSlide] = React.useState(0);
  const child = (item) => (
    <>
      <GatsbyImage
        alt={''}
        className={carrouselStyles.focusWrapper}
        image={getImage(item.media?.imageFile)}
        loading="eager"
        style={{height: '100%', width: 'inherit'}}
      />
      <div
        style={{
          height: 'inherit', width: 'inherit', position: 'absolute', zIndex: 1, top: 0,
        }}
      >
        <div
          className={carrouselStyles.titleContentFocus}
        >
          {item.title && item.link ? (
            <p
              className={clsx(`${carrouselStyles.carrouselTitle} uppercase`, carrouselStyles.focusCarouselH4)}
            >
              <PolyLink
                ariaLabel={item.title}
                rel="noreferrer"
                target={item.action_new_page ? '_blank' : '_self'}
                title={item.title}
                url={toExternalUrl(item.link)}
              >
                <p className={carrouselStyles.colors}>
                  {item.title}
                </p>
              </PolyLink>
            </p>) : (
            <p
              className={carrouselStyles.carrouselTitle}
              style={{
                backgroundColor: 'var(--white-color)', padding: 4,
              }}
            >
              {item.title}
            </p>
          )}
        </div>
      </div>
    </>
  );

  React.useEffect(() => {
    setDisplay(true);
  }, []);

  return (
    <div
      aria-label={items?.aria_label}
      aria-roledescription="carrousel"
      role="group"
      style={{width: '100%', marginBottom: 50}}
    >
      <div className={carrouselStyles.blocFocus}>
        {display &&
          <button
            aria-label={t('carrousel.leftArrow')}
            className={carrouselStyles.leftArrowFocusTest}
            onClick={() => {
              swiper.slidePrev();
            }}
            onKeyDown={(e) => {
              e.currentTarget.click();
            }}
            tabIndex="0"
          >
            <IconContainer
              classname={carrouselStyles.containersvgCarrousel}
              color="WHITE"
              icon="ARROW_LEFT_LARGE"
              size="25"
              svgClassname={carrouselStyles.svgCarrousel}
              variant="contained"
            />
          </button>
        }
        {display &&
          <button
            aria-label={t('carrousel.rightArrow')}
            className={carrouselStyles.rightArrowFocusTest}
            onClick={() => {
              swiper.slideNext();
            }}
            onKeyDown={(e) => {
              e.currentTarget.click();
            }}
            tabIndex="0"
          >
            <IconContainer
              classname={carrouselStyles.containersvgCarrousel}
              color="WHITE"
              icon="ARROW_RIGHT_LARGE"
              size="25"
              svgClassname={carrouselStyles.svgCarrousel}
              variant="contained"
            />
          </button>
        }
        <div className={carrouselStyles.innerBloc}>
          <Swiper
            breakpoints={{
              1: {
                slidesPerView: 1, spaceBetween: 10,
              },
              768: {
                slidesPerView: 2, spaceBetween: 10,
              }, 1250: {
                slidesPerView: 4, spaceBetween: 10,
              },
            }}
            className={clsx({[carrouselStyles.divOnLoadFocus]:!display})}
            loop
            onSlideChange={(core) => {
              setSlide(core.realIndex);
            }}
            onSwiper={(core) => setSwiper(core)}
            slidesPerView={4}
            speed={600}
            style={{height: '100%'}}
          >
            {filteredItems?.map((item, index) => (
              <SwiperSlide
                aria-label={item.aria_label}
                aria-labelledby={'tab-' + index}
                aria-roledescription="diapo"
                className={carrouselStyles.swiperslide}
                id={'panel-' + index}
                key = {'slide_' + index}
                role="tabpanel"
                style={{position: 'relative'}}
              >
                {child(item)}
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={carrouselStyles.thumbnailMargin}>
            <CustomBullets
              current={slide}
              nbBullets={items?.length}
              swiper={swiper}
              total={filteredItems?.length}
            />
          </div>
        </div>
      </div>
    </div>);
};

FocusCarrousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      media: PropTypes.shape({
        imageFile: PropTypes.object.isRequired,
      }),
      title: PropTypes.string,
      link: PropTypes.string,
      action_new_page: PropTypes.bool,
      aria_label: PropTypes.string,
    })
  ),
};

export default FocusCarrousel;
